<template>
  <main>
    <section class="section">
      <div class="container container--medium">
        
        <div class="grid grid--half-bigger">
          <div>
            <!-- <h5 class="heading-xtra-sub">Buy directly from us</h5> -->
            <!-- <h3 class="heading-xtra">MNC Play TV AddOn</h3> -->
            
            
            <!-- <div :class="`bottom-solid pb-20 mb-1 ${idPelanggan && user && user.is_isp === 0? '' : 'op5'}`">
              <h4 class="heading mb-1">Select package</h4>
              <div class="grid grid--fix-two">
                <a 
                  :class="`card mb-1 ${idPelanggan && user && user.is_isp === 0? '' : 'cursor-disabled'} card--active`"
                  href="javascript:void(0)" @click="choose('option', 1)">
                  <span class="card__title">TIMNAS SEPTEMBER</span>
                  <span class="card__sub-title"></span>
                </a>

                <a v-for="item in options" :key="`option-${item.id}`"
                  :class="`card mb-1 ${idPelanggan && user && user.is_isp === 0? '' : 'cursor-disabled'} ${optionSelected === item.id? 'card--active' : ''}`"
                  href="javascript:void(0)" @click="choose('option', item.id)">
                  <span class="card__title">{{ item.title }}</span>
                  <span class="card__sub-title">{{ item.desc }}</span>
                </a>
              </div>
            </div> -->
            <!-- <div :class="`bottom-solid pb-20 mb-1 ${optionSelected && user? '' : 'op5'}`">
              <h4 class="heading">Select your {{ labelOption }}</h4>
              <h5 class="heading heading--sub mb-1">Choose the contents of your {{ labelOption }}</h5>
              <div class="grid grid--fix-two">
                <template v-if="packages.length > 0">
                  <a v-for="item in packages" :key="`package-${item.productgroup}`"
                    :class="`card mb-1 ${optionSelected && user? '' : 'cursor-disabled'} ${packageSelected && packageSelected.productgroup === item.productgroup? 'card--active' : ''}`"
                    href="javascript:void(0)" @click="choose('package', item)">
                    <span class="card__title">{{ removeNumber(item.durations[0].productname) }}</span>
                    <span class="card__sub-title">From {{ rpFormat(item.startPrice) }} / Month</span>
                  </a>
                </template>
              </div>
            </div> -->
            <div :class="`pb-20 mb-1 op5`">
              <h4 class="heading">Select package</h4>
              <!-- <h5 class="heading heading--sub mb-1">More duration, more package discount</h5> -->
             

              <div>
                <div class="grid grid--fix-two" >
                  <!-- <template v-if="durations.length > 0">
                    <a v-for="item in durations" :key="`duration-${item.productcode}`"
                      :class="`card mb-1 ${packageSelected && user? '' : 'cursor-disabled'} ${durationSelected && durationSelected.productcode === item.productcode? 'card--active' : ''}`"
                      href="javascript:void(0)" @click="choose('duration', item)">
                      {{ item |json }}
                      <span class="card__title">{{ totalMonth(item.age) }}</span>
                      <span class="card__sub-title">{{ rpFormat(item.price / (item.age / 30)) }} / Month</span>
                    </a>
                  </template> -->
                  
                  <a v-for="item in hardproductplaybox" :key="`duration-${item.id}`"
                      :class="`card mb-1 card--active`"
                      href="javascript:void(0)" @click="chooseWifi( item)" disable="true">
                    
                      <span class="card__title">{{item.nama }}</span>
                      <span class="card__sub-title">{{ rpFormat(item.harga)}}</span>
                    </a>
                  
                  
                </div>
              </div>

              
            </div>

          </div>
          <div>
            <div>
              <div class="box" >
              <!-- <div class="bottom-dashed pb-20 mb-1">
                <div v-if="user">
                  <h4 class="heading heading--user">{{ user.fullname }}</h4>
                  <p class="heading--user-desc">Customer ID {{ user.customerid }}</p>
                  
                </div>
                <h4 v-else class="heading weight-700">User</h4>
              </div> -->
              <div class="bottom-dashed pb-20 mb-1">
                <h4 class="heading">Invoice</h4>
                <div v-if="durationSelected">
                  <ul class="list list--invoice">
                    <li v-if="newlistInvoice">
                      <p>{{ removeNumber(newlistInvoice.nama) }}</p>
                      <p>{{ rpFormat(newlistInvoice.harga) }}</p>
                    </li>

                    <li v-if="newlistInvoice">
                      <p>PPN</p>
                      <p>{{ rpFormat(newlistInvoice.ppn) }}</p>
                    </li>
                    <li v-if="newlistInvoice">
                      <p>Admin fee</p>
                      <p>{{ rpFormat(parseInt(newlistInvoice.admin_fee)) }}</p>
                    </li>

                  </ul>
                  <div class="heading--total" v-if="newlistInvoice">
                    <p>Total</p>
                    <!-- <p>{{ rpFormat(durationSelected.price) }}</p> -->
                    <p>{{ rpFormat(newlistInvoice.price_final) }}</p>
                  </div>
                </div>
                <p v-else>-</p>
              </div>
              <div v-if="showQris" class="text-center">
                <img v-bind:src="imageqris">
                <a class="button button--submit" style="margin: 2px 0px 5px;
    border-radius: 10px;
    width: 170px;
    font-size: 15px;" v-bind:href="imageqris" download="qris-addon.png">Download QRIS</a>
              </div>
              <!-- {{ newlistInvoice | json }} -->
              <div v-if="(newlistInvoice && newlistInvoice.price_final > 0) || (newlistInvoice && newlistInvoice.current_bal > 0)">
                <!-- <a :class="`button button--submit disabled ${durationSelected ? '' : 'disabled'} text-center`" @click="checkout" style="width:50%; float:left;" disable="true">
                  <div v-if="isLoading" class="loader"></div>
                  <template v-else style="width:50%">VA</template>
                </a> -->

                <a :class="`button button--submit ${durationSelected? '' : 'disabled'} text-center`" @click="checkoutqris" style="width:100%; float:right;">
                  <div v-if="qrsIsLoading" class="loader"></div>
                  <template v-else >QRIS</template>
                </a>
                <div style="clear: both;"></div>
              </div>
            
            <div style="margin-top:20px;" class="pb-20" v-if="showQris" >
              <ul class="list list--invoice">
                    <li style="padding: 10px;">
                      <p><strong>Perhatian : Halaman jangan ditutup atau direfresh.</strong></p>
                    </li>
                    <li style="padding:10px;">
                      <p>Username dan Password akan muncul setelah anda melakukan pembayaran.</p>

                    </li>

                    <li v-if="qrisOrder.isUnpaid" style="padding:10px;">
                      <p>Menunggu pembayaran .....</p>
                    </li>
                    <li v-if="qrisOrder.isPaid" style="padding:10px;">
                      <p>Pembayaran Berhasil</p>
                    </li>
                    <li  v-if="qrisOrder.isPaid" style="padding:10px;">
                      <div class="card mb-1 card--active">
                        <div><p>Username : {{ qrisOrder.username }}</p>
                        </div>
                        <div><p>Password    : {{ qrisOrder.password }}</p></div>
                      </div>
                      
                    </li>

                  </ul>
            </div>  


            <div class="box" style="position: static; margin-top: 15px;" >
              <div class="bottom-dashed pb-20 mb-1">
                <h6 style="text-align: center;">
                  <img src="@/assets/images/logoste.png" style="width:90%"/>

                </h6>
                <div style="margin-top:15px;text-align: center;font-family: Arial, Helvetica, sans-serif;">
                 
                  <b>Dapatkan diskon 30%</b> produk Stetes stevia <br>melalui official Webstore <br><b>www.stetes.id/info</b> <br>
                  untuk setiap pembelian paket add-on <br><b>ASEAN CUP</b> 
                
                </div>
              </div>

            </div>
          </div>
          <div >
            <!-- <video class="box"
              ref="videoPlayer"
              width="260"
              controls
              :src="videoSrc"
              :autoplay="autoplay"
              :muted="muted"
              :loop="loop"
              style="padding:0px"
            >
              Your browser does not support the video tag.
            </video> -->
            
            <!-- <video controls width="250">
              <source src="/assets/video/Video-vplus.mp4" type="video/mp4" />
              <source src="/assets/video/Video-vplus.ogg" type="video/ogg"/>
            </video> -->
          </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>

    <div :class="`modal-mobile ${durationSelected? 'active detail-active' : ''}`">
      <div class="close-modal" @click="() => {durationSelected = null; bodyClass.remove('scroll-hidden-mobile')}"></div>
      <div class="contents box-mobile">
        <!-- <div class="line-top mb-1"></div> -->
        <div :class="`detail`">
          <div class="mb-1">
            <div v-if="user">
              <!-- <h4 class="heading--user-desc">{{ user.fullname }}</h4>
              <p class="heading--user-desc">Customer ID {{ user.customerid }}</p> -->
              <!-- <p class="heading--user-desc">SN {{ user.sn }}</p> -->
            </div>
          </div>
          <div class="mb-1">
            <h4 class="heading">Payment Details</h4>
            <ul class="list list--invoice">
              <ul class="list list--invoice">
                    <li v-if="listInvoice">
                      <p>Tagihan Berjalan</p>
                      <p>{{ rpFormat(listInvoice.accountBal) }}</p>
                    </li>

                    <li v-if="newlistInvoice">
                      <p>{{ removeNumber(newlistInvoice.productname) }}</p>
                      <p>{{ rpFormat(newlistInvoice.price) }}</p>
                    </li>

                    <!-- <li>
                      <p>{{ removeNumber(durationSelected.productname) }}</p>
                      <p>{{ rpFormat(durationSelected.price) }}</p>
                    </li> -->

                    <li v-if="newlistInvoice">
                      <p>PPN</p>
                      <p>{{ rpFormat(newlistInvoice.ppn) }}</p>
                    </li>
                    <li v-if="newlistInvoice">
                      <p>Admin fee</p>
                      <p>{{ rpFormat(parseInt(newlistInvoice.admin_fee)) }}</p>
                    </li>

                  </ul>
                  <div class="heading--total" v-if="newlistInvoice">
                    <p>Total</p>
                    <!-- <p>{{ rpFormat(durationSelected.price) }}</p> -->
                    <p>{{ rpFormat(newlistInvoice.price_final) }}</p>
                  </div>
            </ul>
          </div>
          <!-- <div class="flex justify-between align-center mb-half-1">
            <h4 class="heading mb-0">Payment method</h4>
            <a href="javascript:void(0)" class="size-14px">add payment methods</a>
          </div>
          <div :class="`mb-2 ${user? '' : 'op5'}`">
            <a :class="`card card--payment mb-1 ${paymentSelected === 1? 'card--active' : ''}`" href="javascript:void(0)" @click="choose('payment', 1)">
              <img src="@/assets/images/icons/master-card.svg" alt="master card">
              <div>
                <p class="heading--payment">Buy with Card</p>
                <p class="heading--payment-sub">Credit / Debit Card</p>
              </div>
            </a>
            <a :class="`card card--payment mb-1 ${paymentSelected === 2? 'card--active' : ''}`" href="javascript:void(0)" @click="choose('payment', 2)">
              <img src="@/assets/images/icons/cod.svg" alt="cod">
              <div>
                <p class="heading--payment">Cash on Delivery</p>
                <p class="heading--payment-sub">Pay when you receive</p>
              </div>
            </a>
          </div> -->
        </div>
        <div class="grid grid--fix-two" v-if="newlistInvoice">
          <div>
            <p class="heading--user-desc"><b>Total</b> <span>(1 item)</span></p>
            <p class="heading--total">{{ rpFormat(newlistInvoice.price_final) }}</p>
          </div>
          <div v-if="showQris" class="text-center">
            <img v-bind:src="imageqris" style="width:100%">
          </div>
          <!-- <a class="button button--submit text-center" @click="checkout">
            <div v-if="isLoading" class="loader"></div>
            <template v-else>Bayar</template>
          </a>
          <a class="button button--submit text-center" @click="checkout">
            <div v-if="isLoading" class="loader"></div>
            <template v-else>Bayar QRIS</template>
          </a> -->
        </div>
        <div class="grid grid--fix-two" v-if="newlistInvoice">
          <!-- <div>
            <a class="button button--submit text-center disabled" @click="checkout">
            <div v-if="isLoading" class="loader"></div>
            <template v-else>Bayar VA</template>
          </a>
          </div> -->

          <a class="button button--submit text-center" @click="checkoutqris">
            <div v-if="qrsIsLoading" class="loader"></div>
            <template v-else>Bayar QRIS</template>
          </a>
          
          
        </div>
      </div>
    </div>

    <!-- Pop up didn't use -->
    <div :class="`modal ${popUp? 'active' : ''}`">
      <div class="close-modal" @click="popUp = !popUp"></div>
      <div class="contents box-alert">
        <img class="close" src="@/assets/images/icons/close.svg" alt="close button" @click="popUp = !popUp">
        <!-- <div class="text-center mb-2">
          <img class="icon" src="@/assets/images/icons/success.svg" alt="">
          <h3 class="head-alert success">Pembayaran Berhasil</h3>
        </div> -->
        <div class="text-center mb-2">
          <img class="icon" src="@/assets/images/icons/failed.svg" alt="">
          <h3 class="head-alert failed">Pembayaran Gagal</h3>
        </div>
        <div class="mb-half-1">
          <h4 class="heading--user-desc">Details</h4>
          <p class="heading--user-desc">Customer ID 2100000778</p>
          <p class="heading--user-desc">SN 19102600003344</p>
        </div>
        <div class="mb-half-1">
          <h4 class="heading--user-desc">Transfer Amount</h4>
          <p class="heading--user-desc">Rp. 360.000</p>
        </div>
        <div>
          <h4 class="heading--user-desc">Tanggal Pembayaran</h4>
          <p class="heading--user-desc">Jumat, 23 November 2021 19:20</p>
        </div>
        <div class="mt-2">
          <a class="button button--submit text-center" href="javascript:void(0)">Coba Lagi</a>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from 'axios'
// import vouchers from '../json/vouchers'
// import packages from '../json/packages'

export default {
  name: 'Home',
  data () {
    return {
      selectedCustomer: 'IPTV',
      isLoading: false,
      qrsIsLoading : false,
      bodyClass: null,
      idPelanggan: null,
      idPelTemp: null,
      msgError: '',
      user: {},
      listUser: [],
      imageqris: null,
      showQris:false,
      optionSelected: null,
      packageSelected: null,
      durationSelected: null,
      listInvoice:null,
      newlistInvoice:null,
      paymentSelected: null,
      options: [
        {
          id: 3,
          title: 'Premium Channel Package',
          desc: 'From movies to sports, subscribe to numerous Premium Channels in affordable packages!'
        },
        {
          id: 8,
          title: 'Video Streaming Voucher',
          desc: 'Your favorite video streaming platform is here, check the voucher and watch now!'
        }
      ],
      packages: [],
      newpackages : [],
      durations: [],
      hardproduct : [
        //{ "productid": "4974", "productname": "TIMNAS U-17", "age": 30, "price": 39000, "productcode": "TIMNASU17", "provisioningcode":"VP_SUBS_SPRTS_PKG" },
        // { "productid": "4974", "productname": "TIMNAS NOVEMBER", "age": 30, "price": 39000, "productcode": "TIMNASU17", "provisioningcode":"VP_SUBS_SPRTS_PKG" },
        // { "productid": "4967", "productname": "BEIN 01", "age": 30, "price": 49000, "productcode": "BEIN01" },
        // { "productid": "4969", "productname": "BEIN 03", "age": 90, "price": 147000, "productcode": "BEIN03" },
        // { "productid": "4963", "productname": "BEIN 06", "age": 180, "price": 245000, "productcode": "BEIN06" },
        // { "productid": "4965", "productname": "BEIN 12", "age": 360, "price": 441000, "productcode": "BEIN12" },
        // { "productid": "4973", "productname": "QRIS PRODUK", "age": 30, "price": 1000, "productcode": "BEINSPORT" },
      ],
      hardproductplaybox : [
        //{ "productid": "4971", "productname": "TIMNAS NOVEMBER", "age": 30, "price": 39000,"ppn":4290,"admin_fee":6500, "price_final":49790, "productcode": "TIMNAS11", "provisioningcode":"VP_SUBS_SPRTS_PKG" },
      ],
      popUp: false,
      detail: false,
     // Video 
      videoSrc: require("@/assets/video/Video-vplus.mp4"), // Set your video source path
      autoplay: true,
      muted: false,
      loop: true,
      qrisOrder: {
      transactionId: "",
      externalId: "",
      isUnpaid: false,
      isPaid: false,
      username: "",
      password: ""
    }

    }
  },
  watch: {
    idPelanggan (event) {
      setTimeout(() => {
        if (this.idPelanggan && this.idPelanggan !== this.idPelTemp) this.reset()
        this.idPelTemp = event
        if (this.idPelanggan === this.idPelTemp && this.idPelTemp.length > 5) {
          this.getUser()
        } else if (this.idPelanggan.length === 0) {
          this.reset()
          this.msgError = 'You must fill this first'
        }
      }, 300)
    }
  },
  computed: {
    labelOption () {
      let label = 'Package/Voucher'
      if (this.optionSelected === 3) {
        label = 'Package'
      } else if (this.optionSelected === 8) {
        label = 'Voucher'
      }
      return label
    }
  },
  methods: {
    async getUser () {
      this.showQris = false;
      const param = { search: this.idPelanggan }
      try {
        const res = await axios.post(`/search`, param)
        if (!res.data.status) {
          this.msgError = 'User not found'
          this.reset()
          return
        }
        this.$ga.event('Payment', 'search', 'Search SubsID', this.idPelanggan)
        this.msgError = ''
        this.listUser = res.data.data
        if (this.listUser.length === 1 && this.listUser[0].is_isp === 0) {
          this.user = this.listUser[0];
         this.user.email = res.data.info.email;
          if ( this.user.customerid.toString().substr(0,2) == '21'){
            this.selectedCustomer = 'PLAYBOX';
          }else {
            this.selectedCustomer = 'IPTV';
          }
        }
        this.getProducts()
      } catch (error) {
        console.log(error)
      }
    },
    async getNewPriceInvoice () {
      //const param = { accountid: this.idPelanggan, serviceid: this.durationSelected.productid }
      try {
        console.log(this.durationSelected);
        this.newlistInvoice = this.durationSelected;
        //if (this.listUser.length === 1 && this.listUser[0].is_isp === 0) this.user = this.listUser[0]
      } catch (error) {
        console.log(error)
      }
    },
    async getPriceInvoice () {
      const param = { accountid: this.idPelanggan, serviceid: this.durationSelected.productid }
      try {
        const res = await axios.post(`/getprice`, param)
        if (!res.data.status) {
          this.msgError = 'User not found'
          this.reset()
          return
        }
       // this.$ga.event('Payment', 'search', 'Search SubsID', this.idPelanggan)
        this.msgError = ''
        this.listInvoice = res.data.data

        console.log(this.listInvoice);
        if (this.listUser.length === 1 && this.listUser[0].is_isp === 0) this.user = this.listUser[0]
      } catch (error) {
        console.log(error)
      }
    },
    async getPriceInvoicePlaybox () {
      //const param = { client:"playbox", accountid: this.user.customerid, serviceid: this.durationSelected.productid, servicename:this.durationSelected.productname }
      try {
        // const res = await axios.post(`/getprice`, param)
        // if (!res.data.status) {
        //   this.msgError = 'User not found'
        //   this.reset()
        //   return
        // }
       // this.$ga.event('Payment', 'search', 'Search SubsID', this.idPelanggan)
        this.msgError = ''
       // this.listInvoice = res.data.data
        this.newlistInvoice = this.durationSelected;
        
        console.log(this.listInvoice);
        if (this.listUser.length === 1 && this.listUser[0].is_isp === 0) this.user = this.listUser[0]
      } catch (error) {
        console.log(error)
      }
    },
    async getListWifiPackage () {
      const param = { producttype: this.optionSelected }
      console.log('wifi');
      try {
        axios.get(`https://apiv2-dev.mncplay.id/api/hotspot/getProductWifi`, { params: param })
        .then(res => {
          console.log(res.status);
          console.log(res.data.data);
          this.hardproductplaybox = res.data.data;
        })
        .catch(error => {
          console.error(error);
        });
       // console.log(res.status);
        // if (res.status.code == 200) {
        //   this.packages = res.data.data
        //   this.hardproductplaybox = res.data;
        // }
      } catch (error) {
        console.log(error)
      }
    },
    async getListAddOns () {
      const param = { producttype: this.optionSelected }
      console.log('hai')
      try {
        const res = await axios.post(`/groupproductaddon`, param)
        if (res.data.status) {
          this.packages = res.data.data
        }
      } catch (error) {
        console.log(error)
      }
    },
    async checkout () {
      if (!this.durationSelected || this.isLoading) return

      this.isLoading = true
      // const params = { ID: this.durationSelected.productcode, CID: this.user.customerid }
      const params = {
                      accountid: this.user.customerid,
                      account_bal: this.listInvoice.accountBal,
                      amount: this.listInvoice.amount,
                      current_bal: this.listInvoice.current_bal,
                      otherCost: this.listInvoice.totOthercost,
                      serviceid: this.listInvoice.promoPkgRet,
                      servicename: this.listInvoice.service_pkgRet,
                      price: this.listInvoice.price_pkgRet  
                  }
      try {
        const res = await axios.post(`/checkoutppg`, params)
        if (!res.data.status) {
          this.isLoading = false
          alert(res.data.data.message)
          return
        }
        // this.$ga.event('Payment', 'select_package', 'Select Package', this.packageSelected.productgroup)
        // this.$ga.event('Payment', 'select_duration', 'Select Duration', this.durationSelected.productcode)
        // this.$ga.event('Payment',  'checkout', 'Checkout', 'success')

        // window.location.href = `https://b2b-api.mncplay.id/billmain.php?CID=${this.user.customerid}`

        setTimeout(() => {
          this.isLoading = false
          window.location.href = `https://b2b-api.mncplay.id/billmain.php?CID=${this.user.customerid}`
          }, 2000)

       
       // this.postWaNotif(res.data.data)
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    async getProducts () {
      let ct = 1;
      if ( this.selectedCustomer == 'PLAYBOX'){
        ct = 2;
      }

      const param = { producttype: this.optionSelected, accountid: this.idPelanggan, customertype: ct}
      try {
        const res = await axios.post(`/product`, param)
        if (res.data.status) {
          this.newpackages = res.data;
          this.hardproductplaybox = res.data.data;
          const result = Object.keys(this.newpackages).map((key) => [this.newpackages[key]]);
          console.log(result);
          //console.log(res.data.data);
          this.hardproduct = res.data.data;
          console.log(this.hardproduct);

        }
      } catch (error) {
        console.log(error)
      }
    },

    async checkoutqris () {
      if (!this.durationSelected || this.qrsIsLoading) return

      this.qrsIsLoading = true
      // const params = { ID: this.durationSelected.productcode, CID: this.user.customerid }
      //let provcode = '';
      // if ( this.user.stbtype == 2 ){
      //   provcode = this.durationSelected.provisioningcode_playbox;
      // }else{
      //   provcode = this.durationSelected.provisioningcode;
      // }

      //let prodcode = this.durationSelected.productcode;
      
      // if ( this.selectedCustomer == 'PLAYBOX'){
      //   prodcode = this.durationSelected.provisioningcode;
      // }
            // $post['m_jenisproduct_id'] : 4,
            // $post['m_productwifi_id'] : 18,
            // $post['m_serverwifi_id'] : "hotspot1"

      const params = {
                      accountid: this.user.customerid,
                      terminal_id: "Fm_Qris_Mnc",
                      amount: this.newlistInvoice.price_final,
                      description: "Description of transaction",
                      fullname: 'User',
                      email: 'email@email.com',
                      phone_number: '-',
                      stbtype: '',
                      m_jenisproduct_id: 4,
                      m_productwifi_id : this.durationSelected.id,
                      m_serverwifi_id : 'hotspot1'
                  }
      try {
        const res = await axios.post(`/qrisorder`, params)
        console.log(res.data);
        if (!res.data.status) {
          console.log('false');
          this.qrsIsLoading = false
          alert(res.data.data.message)
          return
        }

        if (!this.qrisOrder) {
          this.qrisOrder = {};
        }
  
        this.showQris = true;
        this.imageqris = res.data.qris;
        const responseData = res.data.order.data;
        this.qrisOrder.transactionId = responseData.detail.data.transaction_id;
        this.qrisOrder.externalId = responseData.detail.data.external_id;
        console.log(this.qrisOrder);
        this.qrsIsLoading = false;
        this.startFetching();

        
      } catch (error) {
        console.log(error)
        this.qrsIsLoading = false
      }
    },
    async postWaNotif (data) {
      const params = {
        customer_id: data.account_id,
        paketname: data.paketname,
        sn: data.sn,
        price: data.price,
        nohp: data.nohp
      }
      try {
        await axios.post(`/wanotif`, params)
        this.isLoading = false
        window.location.href = `https://b2b-api.mncplay.id/billmain.php?CID=${data.account_id}`
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    reset (delUser = true) {
      if (delUser) {
        this.user = null
        this.listUser = []
      }
      this.optionSelected = null
      this.packageSelected = null
      this.durationSelected = null
      this.paymentSelected = null
      this.packages = []
      this.newpackages = []
      this.durations = []
      this.showQris = false;
      this.qrisOrder = {};
    },
    selectUser (val) {
      this.user = val
      console.log(this.user.customerid.toString().substr(0,2))
      if ( this.user.customerid.toString().substr(0,2) == '21'){
        this.selectedCustomer = 'PLAYBOX';
      }else {
        this.selectedCustomer = 'IPTV';
      }
      this.reset(false)
    },
    chooseWifi(val){
      this.paymentSelected = val
        this.durationSelected = val
        //this.getPriceInvoicePlaybox();

       
        this.bodyClass.add('scroll-hidden-mobile');
        // this.$ga.event('Payment', 'select_duration', 'Select Duration', val.productcode)
        this.paymentSelected = null;
        this.showQris = false;
        this.newlistInvoice = this.durationSelected;
        this.newlistInvoice.ppn = (0.11 * val.harga);
        this.newlistInvoice.admin_fee = 7500;
        this.newlistInvoice.price_final = this.newlistInvoice.harga + this.newlistInvoice.ppn + this.newlistInvoice.admin_fee;


    }
    ,
    choose (type, val) {
      if (!this.user || this.user.is_isp === 1) return

      if (this.bodyClass.contains('scroll-hidden-mobile')) this.bodyClass.remove('scroll-hidden-mobile')

      if (type === 'option') {
        this.optionSelected = val
        this.packageSelected = null
        this.durationSelected = null
        this.paymentSelected = null
        this.durations = []
        this.getListAddOns()
      } else if (type === 'package') {
        this.packageSelected = val
        // this.$ga.event('Payment', 'select_package', 'Select Package', val.productgroup)
        this.durations = val.durations
        this.durations.sort((a,b) => {
          return a.age - b.age
        })
        this.durationSelected = null
        this.paymentSelected = null
      } else if (type === 'duration') {
        this.durationSelected = val
        //this.getPriceInvoice();
        this.getNewPriceInvoice();
       
        this.bodyClass.add('scroll-hidden-mobile');
        // this.$ga.event('Payment', 'select_duration', 'Select Duration', val.productcode)
        this.paymentSelected = null;
        this.showQris = false;

      
      } else if (type === 'payment') {
        this.paymentSelected = val
      } else if (type === 'durationplaybox') {
        this.paymentSelected = val
        this.durationSelected = val
        this.getPriceInvoicePlaybox();

       
        this.bodyClass.add('scroll-hidden-mobile');
        // this.$ga.event('Payment', 'select_duration', 'Select Duration', val.productcode)
        this.paymentSelected = null;
        this.showQris = false;
      }
    },
    totalMonth (val) {
      let total = val / 30
      return `${total} ${total > 1? 'Months': 'Month'}`
    },
    rpFormat (val) {
      if (!val) return
      if (val !== parseInt(val, 10)) {
        let valTemp = (Math.round(val * 100) / 100).toString().split('.')
        return `Rp. ${valTemp[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")},${valTemp[1]}`
      }

      return `Rp. ${val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}`
    },
    removeNumber (val) {
      if (val) return val.split(/[0-9]/g)[0].trim()
    },
    periodOpen(_date, _until){
      const toOpen = new Date(_date);
      const toClose = new Date(_until);
      const now = new Date();
      console.log(toOpen, now,toClose);
      if ( now >= toOpen && now <= toClose){
        return true;
      }else{
        return false;
      }
    },
    // video
    playVideo() {
      this.$refs.videoPlayer.play();
    },
    pauseVideo() {
      this.$refs.videoPlayer.pause();
    },
    toggleMute() {
      this.muted = !this.muted;
      this.$refs.videoPlayer.muted = this.muted;
    },
    /*-------------------------------------*/
    async fetchTransactionDetails() {
      const param = { transaction_id: this.qrisOrder.transactionId, external_id: this.qrisOrder.externalId, terminal_id: "Fm_Qris_Mnc" };
      try {
        const response = await axios.post(
          "https://pembayaran-api-dev.mncplay.id/api/getWifiDetail",
          param
        );
        this.transactionDetails = response.data;
        console.log(this.transactionDetails);
        if ( this.transactionDetails.status ){
          console.log('ini true');
          this.qrisOrder.isUnpaid = false;
          this.qrisOrder.isPaid = true;
          this.qrisOrder.username = this.transactionDetails.username;
          this.qrisOrder.password = this.transactionDetails.password;
          
          this.stopFetching();
        }else{
          console.log('ini false');
          this.qrisOrder.isUnpaid = true;
          this.qrisOrder.isPaid = false;

        }
        console.log(this.qrisOrder);
        console.log("Data:", this.transactionDetails);
       
      } catch (error) {
        console.error("Error fetching data:", error);
        //this.stopFetching();
      }
    },
    startFetching() {
      // Set interval untuk memanggil API setiap 2 detik
      this.intervalId = setInterval(this.fetchTransactionDetails, 3000);
    },
    stopFetching() {
      // Hentikan interval jika tidak diperlukan
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  },
  async mounted () {
    // https://mvn-web-purchase.web.app?customerid=2100000150&producttype=3&productcode=VPPremium30
    this.bodyClass = document.getElementsByTagName('body')[0].classList
    const query = this.$route.query
    await this.getListWifiPackage();
    //await this.getProducts();
    console.log('first');
    if (query.customerid && query.producttype && query.productcode) {
      this.idPelTemp = await query.customerid
      this.idPelanggan = await query.customerid
      this.optionSelected = parseInt(query.producttype)
      await this.getListAddOns()
      this.packageSelected = await this.packages.filter(item => item.durations.find(item => item.productcode === query.productcode))[0]
      this.durations = await this.packageSelected.durations
      this.durationSelected = await this.durations.filter(item => item.productcode === query.productcode)[0]
      this.bodyClass.add('scroll-hidden-mobile')
    }
  },
  beforeUnmount() {
    this.stopFetching(); // Hentikan polling saat komponen dihancurkan
  }
}
</script>
